module.exports = __webpack_public_path__ + "img/8.e13729a9.webp";